<div class="welcome-page-view__container">
  <empathy-viewer-template-card [noHeader]="true">
    @if (welcomeDetails().stimulus.length > 0) {
      <empathy-stimulus slot="stimulus" [expandable]="false" [stimulus]="welcomeDetails().stimulus"></empathy-stimulus>
    }

    <div slot="details">
      @if (welcomeDetails().useTitleInd) {
        <h1 class="title survey-viewer__html-content fs__xxl fw__600" [innerHTML]="welcomeDetails().title"></h1>
      }
      <div class="survey-viewer__html-content fs__xl fw__400" [innerHTML]="welcomeDetails().html"></div>
    </div>

    <empathy-viewer-button
      slot="actions"
      class="survey-viewer__start-btn"
      [text]="'system.startSurvey' | translate"
      [color]="'primary'"
      [icon]="faArrowRight"
      [iconPosition]="'right'"
      [testId]="'survey-welcome-start'"
      (clicked)="start.emit()"
    ></empathy-viewer-button>
  </empathy-viewer-template-card>
</div>
